export default __webpack_public_path__ + "static/media/pink-gradient-box.deb63516.svg";